export default __webpack_public_path__ + "static/media/facebook_cover.631d2727.png";